import { useState, useEffect } from 'react';

export const useReset = (resetTime: number | null, doReset: () => void) => {
  const [reset, setReset] = useState<number>(resetTime);

  useEffect(() => {
    if (resetTime && resetTime !== reset) {
      doReset();
      setReset(resetTime);
    }
  }, [resetTime]);
};
